import styled from 'styled-components'

export const PopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const PopUpHeader = styled.div`
  background-color: var(--primary);
  min-height: 60px;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
`

export const PopUpTitle = styled.h4`
  color: var(--text-over-primary);
  font-size: 20px;

  @media (max-width: 425px) {
    font-size: 18px;
  }
`

export const PopUpContent = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  min-height: 0;
  overflow: visible;
`

export const InputField = styled.input`
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1px solid var(--border);
  border-radius: 4px;
  outline: none;
  transition: border-color 0.3s;

  &:focus {
    border-color: var(--primary);
  }

  &::placeholder {
    color: var(--grey-lighter);
  }
`
